module.exports = __webpack_public_path__ + "media/src/images/partners/eu_commission-4e4092ec35c249b2cb94b77d4a97b23f.jpg";